import urljoin from 'url-join';
import { portalApi } from './index.api';

const COE = "client-onboarding";

export const coeApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({

		deliveryDate: builder.query({
			query: (projectId) => ({
				url: urljoin(COE, "delivery-date", projectId),
				// baseQueryWithAuth handles authorization header automatically
			})
		}),
		samplesReady: builder.mutation({
			query: (projectId) => ({
				url: urljoin(COE, "samples-ready", projectId),
				// baseQueryWithAuth handles authorization header automatically
				method: 'POST',
			})
		}),
		updateShipping: builder.mutation({
			query: ({ projectId, ...body }) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin(COE, "update-shipping-date", projectId),
				method: 'POST',
				body
			})
		}),
		committed: builder.mutation({
			query: ({ projectId, ...body }) => ({
				url: urljoin(COE, "committed", projectId),
				// baseQueryWithAuth handles authorization header automatically
				method: 'POST',
				body
			})
		}),
		getOnboarding: builder.query({
			query: (projectId) => ({
				url: urljoin(COE, "state", projectId),
				// baseQueryWithAuth handles authorization header automatically
			}),
			providesTags: ['coe-state']
		}),
		updateOnboarding: builder.mutation({
			query: (body) => ({
				url: urljoin(COE, "state", "publish"),
				// baseQueryWithAuth handles authorization header automatically
				method: 'PUT',
				body: {
					instance: body,
					comment: "publish onboarding state"
				},
			}),
			invalidatesTags: ['coe-state']
		}),
	}),
});

export const {
	useDeliveryDateQuery,
	useSamplesReadyMutation,
	useUpdateShippingMutation,
	useCommittedMutation,
	useGetOnboardingQuery,
	useUpdateOnboardingMutation,
} = coeApi;

/* 
√ POST /api/v1/client-onboarding/update-shipping-date/{projectId}
√ POST /api/v1/client-onboarding/committed/{projectId}
√ POST /api/v1/client-onboarding/samples-ready/{projectId}
√ GET /api/v1/client-onboarding/state/{projectId}
√ GET /api/v1/client-onboarding/delivery-date/{projectId}
√ PUT /api/v1/client-onboarding/state/publish
*/